import Scrollbar from 'smooth-scrollbar'
import Choreographer from 'choreographer-js'
import Preload from 'preload-js'
import Promise from 'promise-polyfill'

import WorksData from '../work-data'
import PreloadManifest from '../preload-manifest'

// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}

export default {
  name: 'work',
  watch: {
    '$route': 'populateComp'
  },
  methods: {
    raceTransitions(transitions) {
      let transPrms = []

      transitions.forEach(el => {
        transPrms.push(this.waitTransitionEnd(el.propertyName, el.className))
      })
      return Promise.race(transPrms)
    },
    waitTransitionEnd(propertyName, className) {
      return new Promise(resolve => {
        const el = document.querySelector(`.${className}`)
        const transitionendRef =
          el.addEventListener(window.transitionEnd, event => {
            if (event.propertyName.indexOf(propertyName) >= 0 && event.target.className == className) {
              el.removeEventListener(window.transitionEnd, transitionendRef, false)
              resolve()
            }
          }, false);

          setTimeout(() => {
            el.removeEventListener(window.transitionEnd, transitionendRef, false)
            resolve()
          }, 4000)
      })
    },
    initScrollbar() {
      this.scrollbar = Scrollbar.init(this.$el.querySelector('.Work-contentWrapper'))
      this.scrollbar.addListener(status => { if (typeof this.choreographer !== 'undefined') this.choreographer.runAnimationsAt(status.offset.y) })
    },
    getAnimations() {
      const offsetTop = el => (el.getBoundingClientRect().top + document.body.scrollTop)
      const view = this.scrollbar.getSize()
      const animations =
        Array.prototype.slice.call(this.$el.querySelectorAll('[data-aos]'))
          .map(el => ({
            selector: el,
            range: [offsetTop(el) + (el.offsetHeight / 3) - view.container.height, view.content.height],
            type: 'change',
            style: 'class',
            to: 'aos-animate',
          }))
          .concat([{
            selector: document.querySelectorAll('.Logo'),
            range: [0, view.container.height],
            type: 'syncMainVue',
            style: 'updatedata',
            unit: 'whiteLogo',
            from: true,
            to: false,
          }])

      return animations
    },
    initChoreographer() {
      this.choreographer = new Choreographer({
        customFunctions: {
          syncMainVue: data => {
            if (data.progress < 1 && this[data.unit] == data.to) {
              let appClasses = {}

              this[data.unit] = data.from
              appClasses[data.unit] = data.from
              this.$emit(data.style, { key: 'appClasses', value: appClasses })
            } else if (data.progress >= 1 && this[data.unit] == data.from) {
              let appClasses = {}

              this[data.unit] = data.to
              appClasses[data.unit] = data.to
              this.$emit(data.style, { key: 'appClasses', value: appClasses })
            }
          },
        },
        animations: this.getAnimations()
      })
    },
    initPreload(preloadSet) {
      return new Promise(resolve => {
        const queue = new Preload.LoadQueue(false)

        queue.on('complete', resolve, this)
        queue.loadManifest(PreloadManifest[preloadSet])
        queue.load()
      })
    },
    populateComp() {
      this.work = WorksData[this.$route.params.name]
      this.$emit('updateHead')
    },
    goNext() {
      const beforePreload = new Date()

      this.$emit('updatestate', 1, 'enterWorkFromWork')
      this
        .initPreload(this.work.next)
        .then(() => new Promise(resolve => { // Wait 4000ms if necessary
          const elapsed = new Date() - beforePreload
          setTimeout(resolve, elapsed < 2000 ? 2000 - elapsed : 0)
        }))
        .then(() => { // Update data and wait for next vuejs tick
          this.$router.replace(`/work/${this.work.next}/`)
          this.scrollbar.scrollTo(0, 0, 0)
          return this.$nextTick()
        })
        .then(() => { // Update scrollbar and choreographer
          this.scrollbar.update()
          this.choreographer.updateAnimations(this.getAnimations())
          this.$emit('updatestate', 2, 'enterWorkFromWork')
          return this.waitTransitionEnd('opacity', 'Loader')
        })
        .then(() => { this.$emit('updatestate', 0, 'enterWorkFromWork') })
    },
  },
  created() {
    this.$emit('updatedata', { key: 'appClasses', value: { minLogo: true } })
  },
  mounted() {
    const beforePreload = new Date()
    const clientWidth = document.documentElement.clientWidth
    const clientHeight = document.documentElement.clientHeight
    const getHeight = className =>
      parseInt(window
        .getComputedStyle(this.$el.querySelector(`.${className}`))
        .getPropertyValue('height'))

    this.populateComp()
    this
      .initPreload(this.$route.params.name)
      .then(() => new Promise(resolve => { // Wait 4000ms if necessary
        const elapsed = new Date() - beforePreload
        setTimeout(resolve, elapsed <= 2000 ? 2000 - elapsed : 0)
      }))
      .then(() => { // Start first animation phase
        this.$emit('updatedata', { key: 'appClasses', value: { hiddenLogo: true, } })
        this.$emit('updatestate', 2)

        return this.waitTransitionEnd('opacity', 'Loader')
      })
      .then(() => { // Start second animation phase
        // Ugly workaround for enterWork in mobile mode
        const secondTransPrm =
          clientWidth <= 416 && getHeight('Work-content') == clientHeight
          ? Promise.resolve()
          : this.raceTransitions([
            { propertyName: 'height', className: 'WorkLanding' },
            { propertyName: 'height', className: 'Work-content' },
          ])

        this.$emit('updatestate', 0)
        return secondTransPrm
      })
      .then(() => { // Init scroll and choreographer now that height is fixed
        this.initScrollbar()
        this.initChoreographer()
        this.$emit('updatedata', { key: 'appClasses', value: { whiteLogo: true, hiddenLogo: false, } })
      })
  },
  destroyed() {
    this.scrollbar.destroy(this.$el.querySelector('.Work-contentWrapper'))
    this.choreographer.updateAnimations([])
  },
  data() {
    return {
      work: {
        description: '',
        fields: [''],
        imgSet: [{ src: '', alt: '' }],
        next: '',
        landingImg: { src: '', alt: '' },
        thumbImg: { src: '', alt: '' },
        title: '',
      },
      whiteLogo: true,
    }
  },
  head: {
    title() {
      return {
        inner: 'Fany Righi',
        separator: '—',
        complement: `${this.work.title}`
      }
    },
    meta() {
      return [
        { name: 'description', content: `${this.work.description}`, id: 'meta-description' },
        { name: 'og:title', content: `Fany Righi — ${this.work.title}`, id: 'og-title' },
        { name: 'og:description', content: `${this.work.description}`, id: 'og-description' },
        { name: 'og:url', content: `http://fanyrighi.com/work/${this.$route.params.name}/`, id: 'og-url' },
        { name: 'twitter:title', content: `Fany Righi — ${this.work.title}`, id: 'twitter-title' },
        { name: 'twitter:description', content: `${this.work.description}`, id: 'twitter-description' },
        { name: 'twitter:url', content: `http://fanyrighi.com/work/${this.$route.params.name}/`, id: 'twitter-url' },
      ]
    },
    link() {
      return [
        { rel: 'canonical', href: `http://fanyrighi.com/work/${this.$route.params.name}/`, id: 'meta-canonical' },
      ]
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/Work.js